var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100 41.667H58.333V0H41.667v41.667H0v16.666h41.667V100h16.666V58.333H100V41.667Z"}));
}

Plus.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Plus;

Plus.default = Plus;
